export const environment = {
  production: true,
  API_END_POINT: 'https://docquityclinic.com',
  indonesiaDomain: 'https://docquitycare.id',
  otherDomain: 'https://docquitycare.com',
  hCaptchaSiteKey: 'fb920498-6505-446d-a054-65a5c87c28f1',
  env : 'PROD'
};
